var svgFunction = function svgFunction(svgAttributes, innerContents, defaultClass) {
  return function () {
    var additionalAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var combinedAttributes = {};
    Object.keys(svgAttributes).filter(function (key) {
      return key !== 'xmlns';
    }).forEach(function (key) {
      combinedAttributes[key] = svgAttributes[key];
    });

    if (additionalAttributes) {
      additionalAttributes = 'string' === typeof additionalAttributes ? {
        "class": additionalAttributes
      } : additionalAttributes;
      additionalAttributes['class'] = additionalAttributes['class'] || defaultClass;
      Object.keys(additionalAttributes).filter(function (key) {
        return !svgAttributes[key];
      }).forEach(function (key) {
        combinedAttributes[key] = additionalAttributes[key];
      });
    }

    var attributes = Object.keys(combinedAttributes).map(function (key) {
      return key + '="' + combinedAttributes[key] + '"';
    });
    return '<svg ' + attributes.join(' ') + '>' + innerContents + '</svg>';
  };
};

var id$i = 'arrow-double-1-12';
var attributes$i = {
  "width": "12",
  "height": "12",
  "viewBox": "0 0 12 12",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$i = '<path d="M5.502 9.54V2.451L3.258 4.768l-.718-.695L6 .5l3.382 3.51-.72.694-2.16-2.241v7.084l2.241-2.315.719.695-3.46 3.573L2.62 7.99l.72-.694 2.162 2.243z" fill="currentColor"/>';
var contents$i = '<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">' + innerContents$i + '</svg>';
var defaultClass$i = "tds-icon-12";
var svg$i = svgFunction(attributes$i, innerContents$i, defaultClass$i);
var arrowDouble112 = {
  svg: svg$i,
  id: id$i,
  contents: contents$i,
  innerContents: innerContents$i,
  attributes: attributes$i
};

var id$j = 'arrow-down-1-12';
var attributes$j = {
  "width": "12",
  "height": "12",
  "viewBox": "0 0 12 12",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$j = '<path d="M5.5 9.037V1h1v8.048l2.243-2.317.719.696L6.002 11 2.62 7.49l.72-.695L5.5 9.037z" fill="currentColor"/>';
var contents$j = '<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">' + innerContents$j + '</svg>';
var defaultClass$j = "tds-icon-12";
var svg$j = svgFunction(attributes$j, innerContents$j, defaultClass$j);
var arrowDown112 = {
  svg: svg$j,
  id: id$j,
  contents: contents$j,
  innerContents: innerContents$j,
  attributes: attributes$j
};

var id$n = 'arrow-left-1-18';
var attributes$n = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$n = '<path d="M2.707 9l4.147 4.146a.5.5 0 01-.708.708l-5-5a.5.5 0 010-.708l5-5a.5.5 0 11.708.708L2.707 8H16.5a.5.5 0 110 1H2.707z" fill="currentColor"/>';
var contents$n = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$n + '</svg>';
var defaultClass$n = "tds-icon-18";
var svg$n = svgFunction(attributes$n, innerContents$n, defaultClass$n);
var arrowLeft118 = {
  svg: svg$n,
  id: id$n,
  contents: contents$n,
  innerContents: innerContents$n,
  attributes: attributes$n
};

var id$t = 'arrow-right-1-18';
var attributes$t = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$t = '<path d="M15.293 9l-4.147 4.146a.5.5 0 00.708.708l5-5a.5.5 0 000-.708l-5-5a.5.5 0 10-.708.708L15.293 8H1.5a.5.5 0 100 1h13.793z" fill="currentColor"/>';
var contents$t = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$t + '</svg>';
var defaultClass$t = "tds-icon-18";
var svg$t = svgFunction(attributes$t, innerContents$t, defaultClass$t);
var arrowRight118 = {
  svg: svg$t,
  id: id$t,
  contents: contents$t,
  innerContents: innerContents$t,
  attributes: attributes$t
};

var id$v = 'arrow-up-1-12';
var attributes$v = {
  "width": "12",
  "height": "12",
  "viewBox": "0 0 12 12",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$v = '<path d="M6.502 2.963V11h-1V2.951L3.258 5.269l-.718-.695L6 1l3.382 3.51-.72.694-2.16-2.241z" fill="currentColor"/>';
var contents$v = '<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">' + innerContents$v + '</svg>';
var defaultClass$v = "tds-icon-12";
var svg$v = svgFunction(attributes$v, innerContents$v, defaultClass$v);
var arrowUp112 = {
  svg: svg$v,
  id: id$v,
  contents: contents$v,
  innerContents: innerContents$v,
  attributes: attributes$v
};

var id$J = 'ban-1-18';
var attributes$J = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$J = '<path d="M3.708 15A8 8 0 0015 3.707L3.707 14.999zM3 14.291L14.292 3.001A8 8 0 003 14.293zM9 18A9 9 0 119 0a9 9 0 010 18z" fill="currentColor"/>';
var contents$J = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$J + '</svg>';
var defaultClass$J = "tds-icon-18";
var svg$J = svgFunction(attributes$J, innerContents$J, defaultClass$J);
var ban118 = {
  svg: svg$J,
  id: id$J,
  contents: contents$J,
  innerContents: innerContents$J,
  attributes: attributes$J
};

var id$1P = 'check-circle-1-18';
var attributes$1P = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$1P = '<path d="M9 18A9 9 0 119 0a9 9 0 010 18zm0-1A8 8 0 109 1a8 8 0 000 16zm4.283-11.444a.5.5 0 01.707.707l-6.182 6.181a.5.5 0 01-.707 0l-3.09-3.09a.5.5 0 01.706-.708l2.738 2.738 5.828-5.828z" fill="currentColor"/>';
var contents$1P = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$1P + '</svg>';
var defaultClass$1P = "tds-icon-18";
var svg$1P = svgFunction(attributes$1P, innerContents$1P, defaultClass$1P);
var checkCircle118 = {
  svg: svg$1P,
  id: id$1P,
  contents: contents$1P,
  innerContents: innerContents$1P,
  attributes: attributes$1P
};

var id$6B = 'social-fb-1-18';
var attributes$6B = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg",
  "aria-labelledby": "social-fb-1-18-title"
};
var innerContents$6B = '<path d="M18 9a9 9 0 10-10.406 8.89v-6.288H5.309V9h2.285V7.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V9h2.496l-.399 2.602h-2.097v6.289C14.71 17.215 18 13.492 18 9" fill="#1877F2"/>';
var contents$6B = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-labelledby="social-fb-1-18-title">' + innerContents$6B + '</svg>';
var defaultClass$6B = "tds-icon-18";
var svg$6B = svgFunction(attributes$6B, innerContents$6B, defaultClass$6B);
var socialFb118 = {
  svg: svg$6B,
  id: id$6B,
  contents: contents$6B,
  innerContents: innerContents$6B,
  attributes: attributes$6B
};

var id$6H = 'social-instagram-1-18';
var attributes$6H = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$6H = '<path d="M9 0c2.444 0 2.75.01 3.71.054.959.044 1.613.196 2.185.419.592.23 1.094.537 1.594 1.038.5.5.809 1.002 1.039 1.594.222.572.374 1.226.418 2.184C17.99 6.25 18 6.556 18 9s-.01 2.75-.054 3.71c-.044.959-.196 1.613-.418 2.185a4.412 4.412 0 01-1.039 1.594c-.5.5-1.002.809-1.594 1.039-.572.222-1.226.374-2.184.418C11.75 17.99 11.444 18 9 18s-2.75-.01-3.71-.054c-.959-.044-1.613-.196-2.185-.418a4.412 4.412 0 01-1.594-1.039c-.5-.5-.809-1.002-1.038-1.594-.223-.572-.375-1.226-.419-2.184C.01 11.75 0 11.444 0 9s.01-2.75.054-3.71C.098 4.33.25 3.676.473 3.104A4.411 4.411 0 011.51 1.51c.5-.5 1.002-.809 1.594-1.038C3.677.25 4.33.098 5.289.054 6.25.01 6.556 0 9 0zm0 1.622c-2.403 0-2.688.009-3.637.052-.877.04-1.354.187-1.67.31-.421.163-.72.358-1.036.673-.315.315-.51.615-.673 1.035-.123.317-.27.794-.31 1.671-.043.95-.052 1.234-.052 3.637s.009 2.688.052 3.637c.04.877.187 1.354.31 1.67.163.421.358.72.673 1.036.315.315.615.51 1.035.673.317.123.794.27 1.671.31.95.043 1.234.052 3.637.052s2.688-.009 3.637-.052c.877-.04 1.354-.187 1.67-.31.421-.163.72-.358 1.036-.673.315-.315.51-.615.673-1.035.123-.317.27-.794.31-1.671.043-.95.052-1.234.052-3.637s-.009-2.688-.052-3.637c-.04-.877-.187-1.354-.31-1.67a2.788 2.788 0 00-.673-1.036 2.788 2.788 0 00-1.035-.673c-.317-.123-.794-.27-1.671-.31-.95-.043-1.234-.052-3.637-.052zM9 12a3 3 0 100-6 3 3 0 000 6zm0-7.622a4.622 4.622 0 110 9.244 4.622 4.622 0 010-9.244zm5.884-.182a1.08 1.08 0 11-2.16 0 1.08 1.08 0 012.16 0z" fill="#D72E72"/>';
var contents$6H = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$6H + '</svg>';
var defaultClass$6H = "tds-icon-18";
var svg$6H = svgFunction(attributes$6H, innerContents$6H, defaultClass$6H);
var socialInstagram118 = {
  svg: svg$6H,
  id: id$6H,
  contents: contents$6H,
  innerContents: innerContents$6H,
  attributes: attributes$6H
};

var id$6K = 'social-linkedin-1-18';
var attributes$6K = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg",
  "aria-labelledby": "social-linkedin-1-18-title"
};
var innerContents$6K = '<path d="M16.671 0H1.33C.595 0 0 .595 0 1.329V16.67C0 17.405.595 18 1.329 18H16.67c.734 0 1.329-.595 1.329-1.33V1.33C18 .595 17.405 0 16.671 0z" fill="#0078AB"/><path d="M15.341 15.34h-2.706v-4.695c0-1.385-.589-1.812-1.348-1.812-.803 0-1.59.604-1.59 1.847v4.66H6.99V6.745h2.603v1.191h.034c.262-.53 1.176-1.433 2.572-1.433 1.51 0 3.142.896 3.142 3.522v5.317zM4.011 5.547c-.86 0-1.56-.655-1.56-1.553 0-.897.7-1.554 1.56-1.554.862 0 1.561.657 1.561 1.554 0 .898-.699 1.553-1.56 1.553zM2.66 15.334V6.738h2.706v8.596H2.659z" fill="#FFF"/>';
var contents$6K = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-labelledby="social-linkedin-1-18-title">' + innerContents$6K + '</svg>';
var defaultClass$6K = "tds-icon-18";
var svg$6K = svgFunction(attributes$6K, innerContents$6K, defaultClass$6K);
var socialLinkedin118 = {
  svg: svg$6K,
  id: id$6K,
  contents: contents$6K,
  innerContents: innerContents$6K,
  attributes: attributes$6K
};

var id$6Q = 'social-twitter-1-18';
var attributes$6Q = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "fill": "none",
  "xmlns": "http://www.w3.org/2000/svg",
  "aria-labelledby": "social-twitter-1-18-title"
};
var innerContents$6Q = '<path d="M10.482 7.622L17.04 0h-1.554L9.792 6.618 5.245 0H0l6.876 10.007L0 18h1.554l6.012-6.989L12.368 18h5.245L10.482 7.622zm-2.128 2.474l-.697-.997-5.543-7.93H4.5l4.474 6.4.697.996 5.815 8.319h-2.387l-4.745-6.788z" fill="#000"/>';
var contents$6Q = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="social-twitter-1-18-title">' + innerContents$6Q + '</svg>';
var defaultClass$6Q = "tds-icon-18";
var svg$6Q = svgFunction(attributes$6Q, innerContents$6Q, defaultClass$6Q);
var socialTwitter118 = {
  svg: svg$6Q,
  id: id$6Q,
  contents: contents$6Q,
  innerContents: innerContents$6Q,
  attributes: attributes$6Q
};

var id$6W = 'social-yt-1-18';
var attributes$6W = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg",
  "aria-labelledby": "social-yt-1-18-title"
};
var innerContents$6W = '<path d="M17.624 4.48a2.262 2.262 0 00-1.592-1.601C14.63 2.5 9 2.5 9 2.5s-5.629 0-7.032.379A2.262 2.262 0 00.376 4.48C0 5.893 0 8.84 0 8.84s0 2.949.376 4.362c.207.779.817 1.393 1.592 1.601 1.403.379 7.032.379 7.032.379s5.629 0 7.032-.379a2.262 2.262 0 001.592-1.601C18 11.789 18 8.84 18 8.84s0-2.948-.376-4.36" fill="#DA322A"/><path fill="#FFF" d="M7.16 11.517V6.165l4.704 2.676-4.705 2.676"/>';
var contents$6W = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-labelledby="social-yt-1-18-title">' + innerContents$6W + '</svg>';
var defaultClass$6W = "tds-icon-18";
var svg$6W = svgFunction(attributes$6W, innerContents$6W, defaultClass$6W);
var socialYt118 = {
  svg: svg$6W,
  id: id$6W,
  contents: contents$6W,
  innerContents: innerContents$6W,
  attributes: attributes$6W
};

var id$7j = 'trash-bin-1-18';
var attributes$7j = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$7j = '<path d="M15 7v8.59c0 .782-.61 1.41-1.357 1.41H4.357C3.611 17 3 16.372 3 15.59V7a.5.5 0 00-1 0v8.59C2 16.919 3.052 18 4.357 18h9.286C14.948 18 16 16.918 16 15.59V7a.5.5 0 10-1 0zM5.5 8a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6a.5.5 0 01.5-.5zM9 8a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6A.5.5 0 019 8zm3.5 0a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6a.5.5 0 01.5-.5zm-1-8a.5.5 0 01.5.5V3h5a.5.5 0 110 1H1a.5.5 0 010-1h5V.5a.5.5 0 01.5-.5h5zM11 1H7v2h4V1z" fill="currentColor"/>';
var contents$7j = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$7j + '</svg>';
var defaultClass$7j = "tds-icon-18";
var svg$7j = svgFunction(attributes$7j, innerContents$7j, defaultClass$7j);
var trashBin118 = {
  svg: svg$7j,
  id: id$7j,
  contents: contents$7j,
  innerContents: innerContents$7j,
  attributes: attributes$7j
};

var id$7N = 'x-1-18';
var attributes$7N = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$7N = '<path d="M1.854 1.146L9 8.293l7.146-7.147a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L9.707 9l7.147 7.146a.5.5 0 01-.708.708L9 9.707l-7.146 7.147a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L8.293 9 1.146 1.854a.5.5 0 11.708-.708z" fill="currentColor"/>';
var contents$7N = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$7N + '</svg>';
var defaultClass$7N = "tds-icon-18";
var svg$7N = svgFunction(attributes$7N, innerContents$7N, defaultClass$7N);
var x118 = {
  svg: svg$7N,
  id: id$7N,
  contents: contents$7N,
  innerContents: innerContents$7N,
  attributes: attributes$7N
};

var id$8h = 'folder-arrow-up-1-36';
var attributes$8h = {
  "xmlns": "http://www.w3.org/2000/svg",
  "width": "36",
  "height": "36",
  "viewBox": "0 0 36 36"
};
var innerContents$8h = '<path fill="currentColor" d="M13 2a1 1 0 01.832.445L17.535 8H35a1 1 0 01.993.883L36 9v21c0 2.26-1.74 4-4 4H4c-2.26 0-4-1.74-4-4V3a1 1 0 011-1zm-.536 2H2v26c0 1.102.77 1.923 1.844 1.995L4 32h28c1.155 0 2-.845 2-2V10H17a1 1 0 01-.757-.346l-.075-.1L12.464 4zM18 13.91h.02l.07.003-.09-.004a1.008 1.008 0 01.625.22l.082.073 5.41 5.41a1 1 0 01-1.32 1.496l-.095-.083L19 17.324v11.494a1 1 0 01-1.993.117L17 28.818V17.324l-3.702 3.701a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 5.409-5.409.082-.073.008-.007-.09.08a1.008 1.008 0 01.689-.293H18z"/>';
var contents$8h = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">' + innerContents$8h + '</svg>';
var defaultClass$8h = "tds-icon-36";
var svg$8h = svgFunction(attributes$8h, innerContents$8h, defaultClass$8h);
var folderArrowUp136 = {
  svg: svg$8h,
  id: id$8h,
  contents: contents$8h,
  innerContents: innerContents$8h,
  attributes: attributes$8h
};

var id$bj = 'trv-logo-2color-black-small';
var attributes$bj = {
  "width": "148",
  "height": "30",
  "viewBox": "0 0 148 30",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$bj = '<path d="M116.592 13.025c1.83 0 3.834.25 4.557.453l-.35 2.688c-.865-.138-3.018-.41-4.53-.41-1.671 0-2.237.431-2.384 1.764-.173 1.558.124 1.717 2.374 2.439 3.548 1.173 4.66 1.784 4.277 5.238-.397 3.612-2.077 4.743-6.371 4.743-2.235 0-3.934-.317-4.707-.477l.434-2.709c.486.11 3.074.495 4.614.495 2.076 0 2.66-.36 2.84-2.033.171-1.532-.077-1.734-2.41-2.48-3.706-1.195-4.542-1.805-4.166-5.24.362-3.297 2.073-4.47 5.822-4.47zm-71.074.205l2.25 12.076 4.75-12.076h3.14l-6.866 16.616h-3.184L42.267 13.23h3.251zm57.824 0c3.589 0 5.306.857 4.84 5.059-.311 2.868-1.427 4.018-3.41 4.58l2.138 6.886h-3.12l-2-6.486h-2.533l-.717 6.486h-3.073l1.818-16.525h6.057zm-9.476 0l-.303 2.755H86.96l-.434 3.928h5.354l-.306 2.79h-5.349l-.478 4.288h6.815l-.298 2.764h-9.958L84.12 13.23h9.745zm-19.097 0L73.254 26.99h7.286c-.387 1.75-1.149 2.764-2.91 2.764h-7.818L71.63 13.23h3.138zm-6.541 0l-.305 2.755h-6.602l-.432 3.928h5.355l-.31 2.79h-5.35l-.476 4.288h6.817l-.3 2.764h-9.96l1.82-16.525h9.743zm-30.572-.09l3.271 16.615H37.7l-.512-2.753h-5.373l-1.141 2.753h-3.141l7.106-16.616h3.017zm-15.44.09c3.592 0 5.308.857 4.844 5.059-.315 2.868-1.429 4.018-3.41 4.58l2.137 6.886h-3.095l-2-6.486h-2.559l-.715 6.486h-3.072l1.817-16.525h6.053zm-8.432 0c-.386 1.748-1.149 2.765-2.908 2.765H8.282l-1.49 13.76H3.627l1.514-13.77H0l.305-2.755zm21.83 4.239l-2.722 6.938h3.813l-1.091-6.938zm67.186-1.617h-2.73l-.526 4.796h2.798c1.448 0 2.435-.054 2.702-2.473.268-2.439-.844-2.323-2.244-2.323zm-81.074 0h-2.78l-.532 4.796h2.854c1.447 0 2.435-.054 2.7-2.473.269-2.439-.892-2.323-2.242-2.323z"/><path d="M132.006 11.343v-.017a.088.088 0 00-.079-.087l-.004-.001a7.852 7.852 0 00-1.679-.016l-.007.001a.087.087 0 00-.078.088l-.001.004.002 15.1a1.56 1.56 0 01-3.028.52l-.002-.005a.925.925 0 00-1.765.542l.002.007a3.41 3.41 0 003.234 2.34 3.41 3.41 0 003.405-3.404V11.343z" fill="#E21B23"/><path d="M114.266 11.201a.104.104 0 01-.152-.131l.005-.008C116.978 4.549 123.484 0 131.053 0c7.571 0 14.08 4.553 16.935 11.072l.002.007c.006.012.01.026.01.04a.104.104 0 01-.104.105.117.117 0 01-.049-.013l-.014-.005c-1.311-.774-3.143-1.252-5.17-1.252-2.34 0-4.419.639-5.738 1.63l-.006.005a.104.104 0 01-.127 0l-.006-.004c-1.322-.992-3.401-1.631-5.741-1.631s-4.419.639-5.74 1.63l-.005.004a.106.106 0 01-.123.006l-.009-.008c-1.32-.992-3.402-1.632-5.742-1.632-2.017 0-3.84.473-5.15 1.24l-.01.007z" fill="#E21B23"/>';
var contents$bj = '<svg width="148" height="30" viewBox="0 0 148 30" xmlns="http://www.w3.org/2000/svg">' + innerContents$bj + '</svg>';
var defaultClass$bj = "tds-icon-trv-logo-small";
var svg$bj = svgFunction(attributes$bj, innerContents$bj, defaultClass$bj);
var trvLogo2colorBlackSmall = {
  svg: svg$bj,
  id: id$bj,
  contents: contents$bj,
  innerContents: innerContents$bj,
  attributes: attributes$bj
};

var id$bC = 'trv-logo-umbrella-red';
var attributes$bC = {
  "width": "53",
  "height": "48",
  "viewBox": "0 0 53 48",
  "xmlns": "http://www.w3.org/2000/svg"
};
var innerContents$bC = '<path d="M28.235 17.88v23.089a5.223 5.223 0 01-5.217 5.215 5.224 5.224 0 01-4.955-3.585l-.003-.01a1.414 1.414 0 011.362-1.794c.626 0 1.155.405 1.343.963l.003.007a2.391 2.391 0 002.25 1.589 2.39 2.39 0 002.388-2.385l-.003-23.133.001-.006c0-.07.051-.128.12-.135l.01-.002a12.03 12.03 0 012.572.024l.007.002c.066.006.12.064.12.133l.002.027zM1.056 17.66a.16.16 0 01-.232-.201l.007-.012C5.211 7.47 15.18.501 26.774.501c11.6 0 21.57 6.975 25.945 16.962l.003.01a.15.15 0 01.015.064.16.16 0 01-.159.159.18.18 0 01-.075-.02l-.022-.007c-2.009-1.185-4.815-1.919-7.92-1.919-3.584 0-6.77.98-8.79 2.498l-.01.007a.16.16 0 01-.194 0l-.01-.006c-2.024-1.52-5.21-2.499-8.795-2.499-3.584 0-6.77.98-8.793 2.5l-.008.004a.163.163 0 01-.189.009l-.013-.012c-2.022-1.52-5.213-2.501-8.798-2.501-3.09 0-5.881.726-7.888 1.9l-.017.011z" fill="#F50002"/>';
var contents$bC = '<svg width="53" height="48" viewBox="0 0 53 48" xmlns="http://www.w3.org/2000/svg">' + innerContents$bC + '</svg>';
var defaultClass$bC = "tds-icon-trv-logo-umbrella";
var svg$bC = svgFunction(attributes$bC, innerContents$bC, defaultClass$bC);
var trvLogoUmbrellaRed = {
  svg: svg$bC,
  id: id$bC,
  contents: contents$bC,
  innerContents: innerContents$bC,
  attributes: attributes$bC
};

export { trvLogo2colorBlackSmall as a, ban118 as b, checkCircle118 as c, socialYt118 as d, socialTwitter118 as e, folderArrowUp136 as f, socialLinkedin118 as g, socialInstagram118 as h, trvLogoUmbrellaRed as i, arrowLeft118 as j, arrowRight118 as k, arrowUp112 as l, arrowDown112 as m, arrowDouble112 as n, socialFb118 as s, trashBin118 as t, x118 as x };

//# sourceMappingURL=index-1074b75b.js.map